export default () => ({
  paramsDashboard: '',
  totalSale: 0,
  registeredPayments: 0,
  totalSaleRangeDates: '',
  registeredPaymentsRangeDates: '',
})
